import React from 'react';
import i18next from 'i18next';
import Dialog from '@material-ui/core/Dialog';
import { withTranslation } from 'react-i18next';
import Slide from '@material-ui/core/Slide';
import clsx from 'clsx';
import Image from '../../components/image';
import Label from '../../components/label';
import styles from './view.scss';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function View(props) {
  const { presenter, open, t, i18n, errorCode, errorText } = props;
  let message = 'errors.default_message';
  if (errorText && i18next.exists(errorText) && t(errorText).length > 0) {
    message = errorText;
  }
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={() => presenter?.onCloseClick()}
      TransitionComponent={Transition}
    >
      <div className={clsx(styles.content, 'error-content')}>
        <div className={clsx('error-container', styles.container)}>
          <div className={clsx('error-background-image-container', styles.imageContainer)}>
            <Image
              alt=""
              src={
                i18n.exists('errors.background_image.src') ? t('errors.background_image.src') : ''
              }
              className={clsx('error-background-image', styles.image)}
            />
          </div>
          <div className={clsx('error-inner-container', styles.innerContainer)}>
            <div className={clsx('error-space', styles.space)} />
            <div className={clsx('error-message-container', styles.errorContainer)}>
              <Label className={clsx('error-text', styles.text)} text={t(message)} />
              {errorCode && (
                <Label
                  className={clsx('error-code', styles.errorText)}
                  text={t('errors.code_message', { code: errorCode })}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}

export default withTranslation()(View);
